<template>
<div class="page-content-wrapper">
  <div class="page-content userprofile">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">用户画像</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <!-- <div id="search-bar" class="lp-flex-box">
      <input type="text" name="name" placeholder="输入名称查询" class="form-control" v-model="biz.nickname">
      <button type="button" class="btn blue" @click="query">查询<i class="m-icon-swapright m-icon-white"></i></button>
      <button type="button" class="btn green" @click="detail(0)">新增用户<i class="icon-plus m-icon-white"></i></button>
    </div> -->
    <br>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="text_overflow" style="text-align:center">{{ui.title}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in biz.items">
                <td style="vertical-align:middle;cursor:pointer" @click="changeItem(index)" class="text_overflow">{{item.name}}</td>
              </tr>
            </tbody>
          </table>
          <blockquote style="font-size:14px">
            预计覆盖人数 <font color="green">{{biz.coveredUser}}</font> 人
          </blockquote>
        </div>
        <div class="col-md-8">
          <div class="portlet">
              <div class="portlet-title">
                <div class="caption" style="font-size: 14px;font-weight: 600;">
                  算法定义
                </div>
                <div class="tools">
                  <a href="javascript:;" class="collapse" data-original-title="" title="">
                  </a>
                  <!-- <a href="#portlet-config" data-toggle="modal" class="config" data-original-title="" title="">
                  </a>
                  <a href="javascript:;" class="reload" data-original-title="" title="">
                  </a>
                  <a href="javascript:;" class="remove" data-original-title="" title=""> -->
                  </a>
                </div>
              </div>
              <div class="portlet-body">
                 <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#tab_1_1" data-toggle="tab" aria-expanded="true">
                    已安装应用 </a>
                  </li>
                  <li class="">
                    <a href="#tab_1_2" data-toggle="tab" aria-expanded="false">
                    所属社区 </a>
                  </li>
                  <li class="">
                    <a href="#tab_1_3" data-toggle="tab" aria-expanded="false">
                    出入记录 </a>
                  </li>
                  <li class="">
                    <a href="#tab_1_4" data-toggle="tab" aria-expanded="false">
                    广告点击 </a>
                  </li>
                  <li class="">
                    <a href="#tab_1_5" data-toggle="tab" aria-expanded="false">
                    房产面积 </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane fade active in" id="tab_1_1">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>名称</th>
                          <th>包名</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>美图</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tab-pane fade" id="tab_1_2">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>名称</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>侨鑫汇悦台</td>
                        </tr>
                        <tr>
                          <td>中海花城湾</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="tab-pane fade" id="tab_1_3">
                    <p>
                       出入记录列表
                    </p>
                  </div>
                  <div class="tab-pane fade" id="tab_1_4">
                    <p>
                       点击情况
                    </p>
                  </div>
                  <div class="tab-pane fade" id="tab_1_5">
                    <p>
                       房产情况
                    </p>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    
  </div>
</div>
</template>

<script>
import http from '../../lib/utils/request.js'
import Pager from '../fragment/Pager.vue'
import BootstrapModal from '../fragment/BootstrapModal.vue'
import AccountEdit from './AccountEdit.vue'
import {mapState} from 'vuex'
import mixins from '../../mixins/index'
import common from '../../lib/methods/common.js'
import {MSG_ID, SER_RESP_CODE, USER_PROFILE_DIM} from '../../lib/constant.js'
export default {
  name: 'userprofile',
  mixins: mixins,
  data () {
    return {
      biz: {
        items: [],
        coveredUser: 100,
        cache: {},
        tag: 100
      },
      ui: {
        title: '',
        currIndex: -1
      },
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0
    }
  },
  components: {
    BootstrapModal,
    AccountEdit,
    Pager
  },
  created () {
    window.emitter.on(MSG_ID.MSG_USERPROFILE_LOAD, (...args) => {
      let item = args[0]
      this.ui.title = item.name
      this.biz.tag = item.tag
      this.query()
    })
  },
  mounted () {
    this.query()
    this.$store.dispatch('setHorizontal', {horizontal: USER_PROFILE_DIM})
    setTimeout(() => { window.emitter.emit(MSG_ID.MSG_SYS_HORIZONTALMENU_CLICK) }, 100)
  },
  destroyed () {
    this.$store.dispatch('setHorizontal', {horizontal: []})
    window.emitter.emit(MSG_ID.MSG_SYS_HORIZONTALMENU_RESET)
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    query () {
      let reqdata = {type: this.biz.tag, parent_id: 0}
      http.invoke('bigdata.getTag', reqdata, (data) => {
        this.biz.items = data.content
        this.totalCount = data.total_count
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, AccountEdit, {title: '编辑账号', id: id})
    },
    remove (id) {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '删除账号', (data) => {
        let reqdata = {action: 2, id: id}
        http.invoke('auth.setAccount', reqdata, (data) => {
          window.emitter.emit(MSG_ID.MSG_ACCOUNT_SET_SUCCESS)
        }, (state) => {
          if (state.code !== 2000000) {
            window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, SER_RESP_CODE[state.code])
            return
          }
          switch (state.result) {
            case 1:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '账号不能删除')
              break
            default:
              window.emitter.emit(MSG_ID.MSG_UI_TOAST_ERR, '操作失败')
          }
        })
      })
    },
    changeItem (index) {
      console.log(index)
      if (this.ui.currIndex !== index) {
        if (!this.biz.cache[index]) {
          this.biz.cache[index] = Math.round(Math.random() * 1000000)
        }
        this.biz.coveredUser = this.biz.cache[index]
        this.ui.currIndex = index
      }
    },
    ...common
  },
  computed: {
    ...mapState({
      pager: state => state.pager,
      menu: state => state.menu
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.userprofile {
  background-color: #fff;
}
@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// UserProfile.vue?4b92a09e